import { Href } from './href';

export class ObjectWithHref extends Object {
  href: Href;
}
